import sidebar from './sidebar';
export default sidebar; // import { mapState } from 'vuex'
// import { elMenuItem, elSubmenu } from '../libs/util.menu'
// export default {
//   name: 'u8-layout-sidebar',
//   render (createElement) {
//     return createElement('div', { attrs: { class: 'u8-layout-sidebar' } }, [
//       createElement('el-menu', {
//         props: { collapse: this.collapse, uniqueOpened: true, defaultActive: this.active },
//         ref: 'sidebarMenu',
//         on: { select: this.handleMenuSelect }
//       }, this.sidebar.map(menu => (menu.children === undefined ? elMenuItem : elSubmenu).call(this, createElement, menu))),
//       ...this.sidebar.length === 0 && !this.collapse ? [
//         createElement('div', { attrs: { class: 'u8-layout-sidebar-empty', flex: 'dir:top main:center cross:center' } }, [
//           createElement('i', { props: { class: 'el-icon-orange' } }),
//           createElement('span', {}, '无操作菜单')
//         ])
//       ] : []
//     ])
//   },
//   data () {
//     return {
//       active: '',
//       asideHeight: 300,
//       BS: null
//     }
//   },
//   computed: {
//     ...mapState('u8sdk/menu', [
//       'sidebar',
//       'collapse'
//     ])
//   },
//   watch: {
//     // 折叠和展开菜单的时候销毁 better scroll
//     collapse (val) {
//       // this.scrollDestroy()
//       // setTimeout(() => {
//       //   this.scrollInit()
//       // }, 500)
//     },
//     // 监听路由 控制侧边栏激活状态
//     '$route.fullPath': {
//       handler (value) {
//         this.active = value
//       },
//       immediate: true
//     }
//   }
// }